export const API_PATH_ApiDeviceMgmtDeviceChangeOrder = '/services/devices-mgtm/apiDeviceMgmtDeviceChangeOrder';
